import ABCyaPhaser from '@abcya/abcya_phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class Ghost extends Phaser.GameObjects.Container
{
    constructor(scene, i, p)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;
        this.ind = i;
        this.pCont = p;

        this.popPos = {x:0, y:0};

        this.body = ABCyaPhaser.Images.addImage(0, 0, "ghost"+String(this.ind), this);

        const randoX = Phaser.Math.Between(150, this.scene.mid.x*2 - 150);
        const randoY = Phaser.Math.Between(250, this.scene.mid.y*2 - 350);
        
        if(!gameData.GAME_DONE){
            this.posPieces(this.ind, randoX, randoY);
        }
    };

    posPieces(i, newX, newY){
        if(this.ind == 1 || i == 1){
            if(gameData.GAME_STATE == "intro"){
                this.x = -this.body.width;
                this.y = 400;
                this.angle = 10;
                this.scene.children.moveBelow(this, this.pCont.children.list[2]);
            } else {
                this.popPos.x = this.x = newX;
                this.popPos.y = this.y = newY;
            }
        }

        if(this.ind == 2 || i == 2){
            if(gameData.GAME_STATE == "intro"){
                for(var b = 0; b < this.pCont.children.list.length; b++){
                    if(this.pCont.children.list[b].frame && this.pCont.children.list[b].frame.name == "houseBack"){
                        this.setPosition(this.pCont.children.list[b].x - this.pCont.children.list[b].width/2 + this.body.width/2 - 7, this.pCont.children.list[b].y + this.body.width/2 + 50);
                        this.scene.children.moveBelow(this, this.pCont.children.list[b]);
                    }
                }

                this.scaleX = this.scaleY = .75;
                this.angle = 30;
            } else {

                this.popPos.x = this.x = newX;
                this.popPos.y = this.y = newY;
            }
        }

        if(this.ind == 3 || i == 3){
            if(this.hasPieces){
                this.armL.x = -75;
                this.armL.y = 103;
                this.armR.x = 79;
                this.armR.y = 76;
            }

            if(gameData.GAME_STATE == "intro"){
                this.popPos.x = this.x = newX;
                this.popPos.y = this.y = newY;
            } else {
                this.popPos.x = this.x = newX;
                this.popPos.y = this.y = newY;
            }
        }

        if(this.ind == 4 || i == 4){

            if(gameData.GAME_STATE == "intro"){
                this.x = 600;
                this.y = 200;
            } else {
                this.popPos.x = this.x = newX;
                this.popPos.y = this.y = newY;
            }
        }

        if(gameData.GHOST_ARR.length > 0){
            for(var g = 0; g < gameData.GHOST_ARR.length; g++){
                var x1 = this.x;
                var y1 = this.y;
                var x2 = gameData.GHOST_ARR[g].x;
                var y2 = gameData.GHOST_ARR[g].y;
                var intersection = Math.sqrt( (x2-=x1)*x2 + (y2-=y1)*y2 );

                //if the distance is below 45px, and the answer block is empty, snap the block to it
                //then save which answer block it is on and set that answer block to full
                if(intersection > 0 && intersection <= 140){
                    //console.log("REPOSITIONING");
                    const randoX = Phaser.Math.Between(150, this.scene.mid.x*2 - 150);
                    const randoY = Phaser.Math.Between(250, this.scene.mid.y*2 - 350);
                    this.posPieces(this.ind, randoX, randoY);
                }
            }
        }

        if(this.word){
            this.word.x = this.wordBg.x = this.x;
            this.word.y = this.wordBg.y = this.y + 50;
            this.wordBorder.y = this.wordBg.y - this.wordBg.height/2;

            if(this.ghostWord.length == 3 || this.ghostWord.length == 4){
                this.wordBg.scaleX = .4;
                this.wordBorder.x = this.wordBg.x - this.wordBg.width/2 + 69;
            }
            if(this.ghostWord.length == 5){
                this.wordBg.scaleX = .5;
                this.wordBorder.x = this.wordBg.x - this.wordBg.width/2 + 58;
            }
            if(this.ghostWord.length == 6 || this.ghostWord.length == 7){
                this.wordBg.scaleX = .6;
                this.wordBorder.x = this.wordBg.x - this.wordBg.width/2 + 46;
            }
            if(this.ghostWord.length == 8){
                this.wordBg.scaleX = .7;
                this.wordBorder.x = this.wordBg.x - this.wordBg.width/2 + 35;
            }
            if(this.ghostWord.length == 9){
                this.wordBg.scaleX = .8;
                this.wordBorder.x = this.wordBg.x - this.wordBg.width/2 + 23;
            }
            if(this.ghostWord.length == 10 || this.ghostWord.length == 11){
                this.wordBg.scaleX = .9;
                this.wordBorder.x = this.wordBg.x - this.wordBg.width/2 + 12;
            }
        }

        if(!gameData.GAME_DONE){
            this.moveGhost();
        }
    };

    moveGhost(){
        if(gameData.GAME_STATE == "intro"){
            //console.log("MOVING GHOSTS");
            if(this.ind == 1){
                const coin = Phaser.Math.Between(1, 2);
                const rand = Phaser.Math.FloatBetween(.3, 1);
                const randTime = Phaser.Math.Between(5000,10000);
                const randUp = Phaser.Math.Between(1000,3000);
                const newY = coin == 1 ? this.y - 40 : this.y + 40;

                this.angle = 10;
                this.setScale(rand);
                this.alpha = rand;

                this.tween1 = ABCyaPhaser.Tweens.addTween(this, randUp, {y:newY, yoyo:true, repeat:-1}, Phaser.Math.Easing.Sine.InOut);
                this.tween2 = ABCyaPhaser.Tweens.addTween(this, randTime, {x:this.scene.mid.x*2 + this.body.width/2}, Phaser.Math.Easing.Linear, ()=>{
                    this.rotOut();
                });
            }

            if(this.ind == 2){
                this.tween1 = ABCyaPhaser.Tweens.addTween(this, 500, {angle:-20, delay:Phaser.Math.Between(0,2000)}, Phaser.Math.Easing.Cubic.Out, ()=>{
                    this.rotOut();
                });
            }

            if(this.ind == 3){
                this.setScale(0);
                this.setAngle(-360 * Phaser.Math.Between(1,3))
                this.alpha = 0;
                const randoScale = Phaser.Math.FloatBetween(.4,.75);

                this.tween1 = ABCyaPhaser.Tweens.addTween(this, 1000, {alpha:1, angle:0, scale:randoScale, delay:Phaser.Math.Between(2000,6000)}, Phaser.Math.Easing.Back.Out, ()=>{
                    this.rotOut();
                });
            }
        }
        if(gameData.GAME_STATE == "game" && !gameData.GAME_DONE){
            this.setScale(0);
            this.alpha = 0;

            // const spd = gameData.SPEED + (gameData.WORDS_MADE * gameData.SPEED_ADJ);
            this.tween1 = ABCyaPhaser.Tweens.addTween(this, gameData.SPEED, {alpha:1, scale:1}, Phaser.Math.Easing.Linear, ()=>{
                this.changeState("red");
            });
        }

        if(gameData.GAME_PAUSED == true) this.stopCreature();
    };

    rotOut(){
        //fade the creature out
        if(gameData.GAME_STATE == "intro"){
            if(this.ind == 1){
                this.angle = -10;
                this.setScale(Phaser.Math.FloatBetween(.3, 1));
                this.alpha = this.scale;

                this.tween1 = ABCyaPhaser.Tweens.addTween(this, Phaser.Math.Between(5000,10000), {x:-this.body.width, delay:Phaser.Math.Between(0,2000)}, Phaser.Math.Easing.Linear, ()=>{
                    this.moveGhost();
                });
            }

            if(this.ind == 2){
                this.tween1 = ABCyaPhaser.Tweens.addTween(this, 500, {angle:30, delay:Phaser.Math.Between(500,4000)}, Phaser.Math.Easing.Linear, ()=>{
                    this.moveGhost();
                });
            }

            if(this.ind == 3){
                this.navTween = this.scene.time.delayedCall(Phaser.Math.Between(1000, 3000), ()=>{this.changeState("red");});
            }
        }
    };

    changeState(type){
        this.body?.destroy();
        this.body = null;

        if(type == "black"){
            if(gameData.GAME_STATE == "intro"){
                if(this.ind == 3){
                    this.body = ABCyaPhaser.Images.addImage(0, 0, "ghost3", this);
                    
                    const randoX = Phaser.Math.Between(150, this.scene.mid.x*2 - 150);
                    const randoY = Phaser.Math.Between(250, this.scene.mid.y*2 - 150);
                    this.popPos.x = this.x = randoX;
                    this.popPos.y = this.y = randoY;

                    this.navTween = this.scene.time.delayedCall(Phaser.Math.Between(1000, 3000), ()=>{this.moveGhost();});
                }
            }
        }
        if(type == "red"){
            if(gameData.GAME_STATE == "intro"){
                if(this.ind == 3){
                    this.body = ABCyaPhaser.Images.addImage(0, 0, "ghost3R", this);

                    ABCyaPhaser.Audio.playOneShot(gameData.ATTACK_SOUNDS[Phaser.Math.Between(0,2)], this.scene);

                    const rando = Phaser.Math.FloatBetween(1.3, 2);
                    this.tween1 = ABCyaPhaser.Tweens.addTween(this, 1000, {scale:rando, easeParams:[1, 0.3]}, Phaser.Math.Easing.Elastic.Out, ()=>{
                        this.ghostOut();
                    });
                }
            }
            if(gameData.GAME_STATE == "game"){
                if(this.ind == 1){
                    this.body = ABCyaPhaser.Images.addImage(0, 0, "ghost1R", this);
                }
                if(this.ind == 2){
                    this.body = ABCyaPhaser.Images.addImage(0, 0, "ghost2R", this);
                }
                if(this.ind == 3){
                    this.body = ABCyaPhaser.Images.addImage(0, 0, "ghost3R", this);
                }
                if(this.ind == 4){
                    this.body = ABCyaPhaser.Images.addImage(0, 0, "ghost4R", this);
                }

                this.tween1 = ABCyaPhaser.Tweens.addTween(this, gameData.SPEED/3, {scale:1.5}, Phaser.Math.Easing.Linear, ()=>{
                    this.attack();
                });
            }
        }
    };

    attack(){
        ABCyaPhaser.Audio.playOneShot(gameData.ATTACK_SOUNDS[Phaser.Math.Between(0,2)], this.scene, .3);
        
        this.tween1 = ABCyaPhaser.Tweens.addTween(this, 1000, {angle:-360 * Phaser.Math.Between(1,3), scale:1, easeParams:[1, 0.3]}, Phaser.Math.Easing.Elastic.Out, ()=>{
            this.destroyCreature(true);
        });
    };

    ghostOut(){
        this.tween1 = ABCyaPhaser.Tweens.addTween(this, 1000, {alpha:0, scale:0, easeParams:[1, 0.3]}, Phaser.Math.Easing.Elastic.In, ()=>{
            this.changeState("black");
        });
    };

    setWord(newWord, init){
        const wordObj = newWord;
        let xAdj = this.x;
        let yAdj = this.y + 50;

        if(this.ind == 1){ xAdj = this.x - 20; }
        if(this.ind == 2) {
            xAdj = this.x - 40;
            yAdj = this.y - 50; 
        }
        if(this.ind == 3 || this.ind == 4) { yAdj = this.y + 75; }
        
        if(init){
            this.wordBg = ABCyaPhaser.Images.addImage(xAdj, yAdj, "nameplate", this.scene);

            this.word = ABCyaPhaser.Text.addText(xAdj, yAdj, 30, 0xFFBC00, FontKeys._curse_casualregular, wordObj, this.scene);
            this.ghostWord = this.innerText = wordObj;

            let x = this.wordBg.x;
            let y = this.wordBg.y;

            if(this.ghostWord.length == 3 || this.ghostWord.length == 4){
                this.wordBg.scaleX = .4;
            }
            if(this.ghostWord.length == 5){
                this.wordBg.scaleX = .5;
            }
            if(this.ghostWord.length == 6 || this.ghostWord.length == 7){
                this.wordBg.scaleX = .6;
            }
            if(this.ghostWord.length == 8){
                this.wordBg.scaleX = .7;
            }
            if(this.ghostWord.length == 9){
                this.wordBg.scaleX = .8;
            }
            if(this.ghostWord.length == 10 || this.ghostWord.length == 11){
                this.wordBg.scaleX = .9;
            }
            
            this.wordBorder = ABCyaPhaser.Images.addImage(x, y, "border", this.scene);
            this.wordBorder.visible = false;
            this.wordBorder.scaleX = this.wordBg.scaleX;
        } else {
            if(this.word){
                //console.log("changing word");
                this.word.destroy();
                this.word = null;
            }

            if(wordObj.length > 0){
                this.innerText = wordObj;

                this.word = ABCyaPhaser.Text.addText(xAdj, yAdj, 30, "0xFFBC00", FontKeys._curse_casualregular, wordObj, this.scene);
            } else {
                //console.log("word " + (gameData.WORDS_MADE+1) + " complete!");
                gameData.SPEED -= 100;
                gameData.WORDS_MADE++;
                gameData.WORD = "";

                if(gameData.WORDS_MADE == 10 || gameData.WORDS_MADE == 30 || gameData.WORDS_MADE == 60 || gameData.WORDS_MADE == 100){
                    // console.log("ADD EXTRA GHOST");
                    this.pCont.createGhost(true);
                }

                this.destroyCreature(true, true);
            }
        }
    };

    addStrokedRect(x, y, width, height, radius, color, parent, origin = { x: 0.5, y: 0.5 })
    {
        let graphic = parent.add.graphics();
        let rectangle = new Phaser.Geom.Rectangle(x - (width * origin.x), y - (height * origin.y), width, height);
        graphic.lineStyle(4, color, 1);
        graphic.strokeRoundedRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height, radius);

        return graphic;
    }

    getWord(){
        return this.ghostWord;
    };

    stopCreature(){
        //stop the creatures tweens
        this.scene.tweens.killTweensOf(this);
        this.scene.tweens.killTweensOf(this.body);

        this.navTween?.remove();
        this.navTween?.destroy();
        this.createTween?.remove();
        this.createTween?.destroy();
    };

    destroyCreature(respawn, correct = false){
        //Destroy the creature
        this.stopCreature();

        
        if(gameData.WORDS_SELECTED.indexOf(this.ghostWord) != -1){
            gameData.WORDS_SELECTED.splice(gameData.WORDS_SELECTED.indexOf(this.ghostWord), 1);
        }

        if(this == gameData.GHOST_SEL){
            gameData.GHOST_SEL = null;
            gameData.WORD = "";
        }

        if(gameData.GHOST_ARR.indexOf(this) != -1){
            gameData.GHOST_ARR.splice(gameData.GHOST_ARR.indexOf(this), 1);
        }

        if(!correct && gameData.GAME_STATE == "game"){
            this.scene.loseLife();
        }

        if(respawn){
            if(gameData.LIVES > 0){
                //console.log("respawning ghost");
                const randWait = Phaser.Math.Between(100, 3000);
                this.createTween = this.scene.time.delayedCall(randWait, ()=>{
                    this.scene.createGhost();
                    super.destroy();
                });
            }
        }

        this.removeAll(true);
        this.wordBg?.destroy();
        this.wordBorder?.destroy();
        this.word?.destroy();
    };
}